import { bool, string } from 'prop-types';
import React from 'react';
import styled from 'styled-components';

import { DEFAULT_COLORS } from 'constants/colors';

const TypeAheadSuggestionStyled = styled.div`
    border-bottom: 1px solid ${DEFAULT_COLORS.LIGHTEST};
    color: ${DEFAULT_COLORS.BLACK};
    cursor: pointer;
    font-size: 0.875rem;
    font-weight: 500;
    overflow: hidden;
    padding: 0.4rem 0 0.4rem 0.75rem;
    width: ${({ containerWidth }) => containerWidth};
    &.active {
        background-color: ${DEFAULT_COLORS.LIGHTEST};
        color: ${DEFAULT_COLORS.DARKEST};
    }
`;

const TypeAheadSuggestion = ({ containerWidth, isHighlighted, suggestion }) => {
    return (
        <TypeAheadSuggestionStyled
            className={isHighlighted ? 'active' : ''}
            containerWidth={containerWidth}
        >
            {suggestion}
        </TypeAheadSuggestionStyled>
    );
};

TypeAheadSuggestion.propTypes = {
    containerWidth: string,
    isHighlighted: bool.isRequired,
    suggestion: string.isRequired,
};

TypeAheadSuggestion.defaultProps = {
    containerWidth: '200px',
};

export default TypeAheadSuggestion;
